'use client'

import React, { useEffect, useId, useState } from "react"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import { useDebounceCallback } from "usehooks-ts"
import Checkbox from "@/components/form/Checkbox"
import RangeSlider from "@/components//form/RangeSlider"
import { changeFilters, toggleFilter } from "@/services/search"
import { searchJobs } from "@/api/actions"
import { contractTypes, jobTitles } from "@/services/job"

type FiltersProps = {
    aroeven: Aroeven
}

export default function Filters({
    aroeven
}: FiltersProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()

    const searchParam = 'all'

    return (
        <>
            <Checkbox
                className="actus"
                defaultChecked={searchParams.get(searchParam)?.includes("1")}
                toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, "1").toString()}`, {
                    scroll: false
                })}
                label="Afficher les publications de l'ensemble du mouvement"
            />            
        </>
    )
}